import React from 'react';

const LoadingSpinner = () => (
  <div className="flex items-center justify-center py-10">
    <div className="h-10 w-10 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin" />
  </div>
);

export default LoadingSpinner;
